module.exports = __webpack_public_path__ + "static/img/fish26.293e7e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish26.png
// module id = hJGH
// module chunks = 0